/**
 * Slider Tabs
 *
 * @since 1.3.0
 * @author FriskaMax <support@friskamax.com>
 * @param {jQuery} $ 
 */
(function($) { 
    'use strict';
    
    $('.slider-tabs .tab-content .tab-pane').wartaSliderTab();
})(jQuery);